module.exports = __webpack_public_path__ + "static/media/YF01_3.36c66543.jpg";